import { boot } from 'quasar/wrappers';
import {
  App,
  URLOpenListenerEvent,
} from 'src/../src-capacitor/node_modules/@capacitor/app';
import { EVENTS, LOCALSTORAGE } from 'src/composables/const';
import { useUserStore } from 'src/store/userStore';
import { Router } from 'vue-router';

export default boot(({ router }) => {
  void App.addListener(EVENTS.APP_URL_OPEN, (event: URLOpenListenerEvent) =>
    handler(event, router)
  );
});

export function handler(event: URLOpenListenerEvent, router: Router) {
  const slug = event.url.split('.org').pop();

  if (!slug) return;

  const token = getParameterByName(event.url, 'token');
  if (token) {
    const user = useUserStore();
    localStorage.setItem(LOCALSTORAGE.TOKEN, token);
    user.setToken(token);
  }

  // Push to the route if there is a slug present
  void router.push({
    path: slug,
  });
}

function getParameterByName(URL: string, name: string) {
  const match = RegExp('[?&]' + name + '=([^&]*)').exec(URL);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}
